import { render } from "./WorkModal.vue?vue&type=template&id=a99a5fe6&scoped=true"
import script from "./WorkModal.vue?vue&type=script&lang=js"
export * from "./WorkModal.vue?vue&type=script&lang=js"

import "./WorkModal.vue?vue&type=style&index=0&id=a99a5fe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99a5fe6"]])

export default __exports__